/* eslint-disable no-use-before-define */

import { reportError } from './ErrorReporting';


/**
 * A wrapper around window.localStorage.
 * This can be extended to handle different mechanisms for storing data locally on the client.
 */

let instance = null;
let localStorageAvailable;
let mockStorage = {};

const keysToNotDelete = ['locale', 'readNotifications_-1', 'pwaAppToken'];

export class MockCache {
    static setInstance(newInstance) {
        instance = newInstance;
    }

    /**
     * @param {string | int} key
     */
    remove(key) {
        delete mockStorage[key];
    }

    /**
     * @param {string | int} key
     * @param {string} value
     */
    set(key, value) {
        mockStorage[key] = value;
    }

    /**
     * @param {string | int} key
     * @returns {string | null}
     */
    get(key) {
        return mockStorage[key];
    }

    removeAll() {
        mockStorage = {};
    }

    getAllKeys() {
        return Object.keys(mockStorage);
    }
}

export class LocalCache {
    static setInstance(newInstance) {
        instance = newInstance;
    }

    /**
     * @param {string | int} key
     */
    remove(key) {
        window.localStorage.removeItem(key);
    }

    /**
     * @param {string | int} key
     * @param {string} value
     */
    set(key, value) {
        try {
            window.localStorage.setItem(key, value);
        } catch (error) {
            reportError(error);
        }
    }

    /**
     * @param {string | int} key
     * @returns {string | null}
     */
    get(key) {
        return window.localStorage.getItem(key);
    }

    removeAll() {
        const valueCache = {};
        keysToNotDelete.forEach((key) => {
            valueCache[key] = this.get(key);
        });

        window.localStorage.clear();

        keysToNotDelete.forEach((key) => {
            this.set(key, valueCache[key]);
        });
    }

    getAllKeys() {
        const len = window.localStorage.length;
        const list = [];

        for (let i = 0; i < len; i++) {
            list.push(window.localStorage.key(i));
        }

        return list;
    }
}

const localCacheService = {
    getLocalCacheInstance() {
        if (instance !== null) {
            return instance;
        }

        if (this.isLocalStorageAvailable()) {
            instance = new LocalCache();
            this.clearNonSpecificUserCache();
        } else {
            instance = new MockCache();
        }

        return instance;
    },

    isLocalStorageAvailable(reCheck = false) {
        if (reCheck || localStorageAvailable === undefined) {
            try {
                const x = '__storage_test__';

                window.localStorage.setItem(x, x);
                window.localStorage.removeItem(x);

                localStorageAvailable = true;
            } catch (e) {
                window.console.warn('LocalStorage is unavailable!');
                localStorageAvailable = false;
            }
        }
        return localStorageAvailable;
    },

    getCachePrefix() {
        return 'testPlayer/user';
    },

    clearNonSpecificUserCache() {
        Object.keys(window.localStorage).forEach((key) => {
            if (key.includes(`${this.getCachePrefix()}/-1`)) {
                window.localStorage.removeItem(key);
            }
        });
    },
};

export default localCacheService;
